import zoneAImg from '../assets/screens/zone-a.png';
import zoneBImg from '../assets/screens/zone-b-1.png';
import zoneB2Img from '../assets/screens/zone-b-2.png';
import zoneCImg from '../assets/screens/zone-c-1.png';
import zoneC2Img from '../assets/screens/zone-c-2.png';
import zoneDImg from '../assets/screens/zone-d-1.png';
import zoneD2Img from '../assets/screens/zone-d-2.png';
import {
  ZoneButtonsA,
  ZoneButtonsB,
  ZoneButtonsB2,
  ZoneButtonsC,
  ZoneButtonsC2,
  ZoneButtonsD,
  ZoneButtonsD2,
} from '../molecules/ZoneButtons';

const zoneImages = {
  A: zoneAImg,
  B: zoneBImg,
  B2: zoneB2Img,
  C: zoneCImg,
  C2: zoneC2Img,
  D: zoneDImg,
  D2: zoneD2Img,
};

const zoneButtons = {
  A: ZoneButtonsA,
  B: ZoneButtonsB,
  B2: ZoneButtonsB2,
  C: ZoneButtonsC,
  C2: ZoneButtonsC2,
  D: ZoneButtonsD,
  D2: ZoneButtonsD2,
};

export const getZoneButtonsComponent = (currentZone) => zoneButtons[currentZone]; // eslint-disable-line
export const getZoneBackgroundImage = (currentZone) => zoneImages[currentZone];
